<template>
  <section class="match-game">
    <h1 class="title">{{ trans.get('pages:match_game.title') }}<span>.</span></h1>
    <div class="match-game__container">
      <!--                SWITCH QUIZ MATCH / MATCH BUTTON-->
      <!--            <div class="match-game__switch">-->
      <!--                <div class="desc desc&#45;&#45;lightgrey pb-1 pr-2" :class="{'current-mode': !simpleLike}"> {{ trans.get('pages:match_game.questions') }}</div>-->
      <!--                <div>-->
      <!--                    <label>-->
      <!--                        <input id="switchMatchgame" v-model="simpleLike" type="checkbox" checked="checked" class="tgl tgl&#45;&#45;purple tgl-light tgl-light&#45;&#45;purple">-->
      <!--                        <label for="switchMatchgame"-->
      <!--                               class="tgl-btn">-->
      <!--                        </label>-->
      <!--                    </label>-->
      <!--                </div>-->
      <!--                <div class="desc desc&#45;&#45;lightgrey pb-1 pl-2" :class="{'current-mode': simpleLike}"> {{ trans.get('pages:match_game.standard') }}</div>-->
      <!--            </div>-->
      <div class="match-game__card-behind"></div>
      <div class="match-game__card-behind"></div>
      <div class="match-game__wrapper" v-if="user">

        <div
          v-if="message && message.visible"
          class="match-game__card-on-top"
          :class="{'transition': isVisible}"
        >
          <NoUserMediaCard v-if="message.type === 'MEDIA'" v-model="message" :current="current" @next="load"></NoUserMediaCard>
          <JokerCard v-if="message.type === 'JOKER'" v-model="message" :current="current" @next="nextAction" @skip="skipAction"></JokerCard>
          <LoveCard v-if="message.type === 'LOVE'" v-model="message" :current="current" @next="nextAction" @skip="skipAction"></LoveCard>
          <LikeCard v-if="message.type === 'LIKE'" v-model="message" :current="current" @next="nextAction" @skip="skipAction"></LikeCard>
        </div>
        <div
          v-if="current && current.swipeable===true"
          class="match-game__card-primary"
          :class="{ 'transition': isVisible }"
        >
          <Vue2InteractDraggable
            v-if="isVisible"
            :enabled="!showDetails"
            :interact-out-of-sight-x-coordinate="500"
            :interact-max-rotation="15"
            :interact-x-threshold="100"
            :interact-y-threshold="200"
            :interact-event-bus-events="interactEventBus"
            :interact-block-drag-down="true"
            @draggedLeft="emitAndNext('SKIP')"
            @draggedUp="emitAndNext('JOKER')"
            @draggedRight="emitAndNext('LOVE')"
            :style="interactDraggableStyle"
          >
            <DraggableProfileCard :profile="current.profile" :showProfileDetails="!showDetails"></DraggableProfileCard>

            <div class="match-game__buttons" v-show="showButtons">
              <div v-show="showButtons" class="button button--primary button__match-game button__match-game--like" @click="loveBtn">
                <i class="demo-icon icon-heart"></i>
              </div>
              <div v-show="showButtons" class="button button--secoundary button__match-game button__match-game--dislike" @click="skipBtn">
                <i class="demo-icon icon-close"></i>
              </div>
            </div>

          </Vue2InteractDraggable>
          <p
            v-if="showButtons" class="button__text-icon match-game__read-more"
            :class="{'match-game__read-more--open' : showDetails}"
            @click="!showDetails ? showProfile() : hideDetails(),
                    showDetails ? scrollToElement('profile-details', {behavior: 'smooth'}) : false"
          >
                        <span v-if="!showDetails">
                            {{ trans.get('pages:members.profile_card.read_more') }}
                        </span>
            <span v-else>{{ trans.get('pages:members.buy_profile_access_modal.close_button') }}</span>
            <i class="demo-icon icon-down"></i>
          </p>
          <transition name="fade" appear>
            <div v-if="showButtons" v-show="showDetails">
              <profile-details :profile="current.profile"></profile-details>
            </div>
          </transition>
        </div>

        <div
          v-if="current && current.swipeable===false"
          class="match-game__card-primary"
          :class="{'transition': isVisible}"
        >
          <ProfileCard v-if="current.type === 'USER'" :profile="current.profile"></ProfileCard>
          <NoMoreCard v-if="current.type === 'NO_MORE'" :current="current"></NoMoreCard>
          <NoMoreMatchesCard v-if="current.type === 'NO_MORE_MATCHES'" :current="current" @errorReason="handleErrorReason" @load="load"></NoMoreMatchesCard>
          <NoMoreCoinsCard v-if="current.type === 'NOT_ENOUGH_COINS'" :current="current"></NoMoreCoinsCard>
          <DailyLimitReachedCard v-if="current.type === 'DAILY_LIMIT_REACHED'" :current="current"></DailyLimitReachedCard>
        </div>

        <div v-if="next" class="match-game__card-below">
          <ProfileCard v-if="next.type === 'USER'" :profile="next.profile"></ProfileCard>
          <no-more-card v-if="next.type === 'NO_MORE'" :current="next"></no-more-card>
        </div>
        <div class="match-game__button" v-show="!showButtons && showDetails">
          <div class="button button__match-game button__match-game--like" @click="hideDetails">
            <i class="fa fa-arrow-up"></i>
          </div>
        </div>
      </div>
      <div class="match-game__card-behind"></div>
      <div class="match-game__card-behind"></div>
    </div>

    <div class="clearfix mt-4"></div>
  </section>
</template>
<script>

import MatchGameMixin from '../../../../js/front/components/MatchGame/MatchGameMixin';

import { InteractEventBus, Vue2InteractDraggable } from '../../../../js/packages/vue2-interact/src';

import JokerCard from './JokerCard';
import LoveCard from './LoveCard';
import NoMoreCard from './NoMoreCard';
import { mapGetters } from 'vuex';
import DraggableProfileCard from './DraggableProfileCard';
import ProfileCard from './ProfileCard';
import NoMoreMatchesCard from './NoMoreMatchesCard';
import ProfileDetails from './ProfileDetails';
import LikeCard from './LikeCard';
import NoMoreCoinsCard from './NoMoreCoinsCard';
import NoUserMediaCard from './NoUserMediaCard';
import DailyLimitReachedCard from './DailyLimitReachedCard';

export default {
  name: 'MatchGameComponent',
  mixins: [MatchGameMixin],
  components: { DailyLimitReachedCard, NoUserMediaCard, NoMoreCoinsCard, LikeCard, ProfileDetails, NoMoreMatchesCard, ProfileCard, DraggableProfileCard, NoMoreCard, LoveCard, JokerCard, Vue2InteractDraggable },
  methods: {
    showProfile() {
      this.$store.dispatch('matchGame/showButtons', true);
      this.$store.dispatch('matchGame/showProfileDetails', true);
    },
    scrollToElement(elementClass, options) {
      const el = this.$el.getElementsByClassName(elementClass)[0];

      if (el) {
        setTimeout(() => {
          el.scrollIntoView(options);
        }, 0);
      }
    },
  },
  mounted() {
    this.simpleLike = true;
  }
};
</script>
